import { StorefrontAbTestSchema } from "@redotech/redo-coverage-common/storefront-ab-test";
import * as z from "zod";

export const listStorefrontAbTests = {
  name: "listStorefrontAbTests" as const,
  input: z.object({}),
  output: z.object({ tests: z.array(StorefrontAbTestSchema) }),
};

export const createStorefrontAbTest = {
  name: "createStorefrontAbTest" as const,
  input: z.object({ name: z.string().trim().min(1).max(200) }),
  output: z.object({ test: StorefrontAbTestSchema }),
};
